/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { DeploymentTemplateInfoV2, RepositoryConfig } from '@modules/cloud-api/v1/types'
import type { RegionId } from '@modules/ui-types'

import { getSnapshotRepositories } from '@/reducers/snapshotRepositories'

import SnapshotRepository from './SnapshotRepository'

import type { ReduxState } from '@/types/redux'

interface StateProps {
  snapshotRepositories: { [repositoryName: string]: RepositoryConfig }
}

interface DispatchProps {}

interface ConsumerProps {
  regionId: RegionId
  deploymentTemplate?: DeploymentTemplateInfoV2 | null
  snapshotRepositoryId: string | undefined
  setSnapshotRepositoryId: (snapshotRepositoryId: string | null) => void
}

const mapStateToProps = (state: ReduxState, { regionId }): StateProps => ({
  snapshotRepositories: getSnapshotRepositories(state, regionId) ?? {},
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  {},
)(SnapshotRepository)
